import { readSettingMode } from '@repo/sdk'

export function getStartedGameRoute(
  gameId: string,
  gameSetting: string,
): string {
  const settingMode = readSettingMode(gameSetting)
  return settingMode.mode === 'comparison'
    ? `/parallel/${gameId}`
    : `/play/${gameId}`
}
